import React from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import * as Icons from '@fortawesome/fontawesome-free-solid';
import { faCircle } from '@fortawesome/fontawesome-free-regular';


/*
  THIS IS ONLY A PRESENTATIONAL COMPONENT -
  NO LOGIC SHOULD BE PLACED HERE (except for maybe visual caluclations (like css; active etc)
 */
const Participant = ({
  name,
  value,
  icon,

  onClick,
  onMouseEnter,

  active,
  clicked,
  isHover,

  children,
  ...rest
}) => {
  // Todo: Move this to the css instead
  const styles = { cursor: 'pointer' };

  let textColor = 'white';

  const iconStyles = { border: '1em' };


  if (isHover) {
    styles.color = 'grey';
    textColor = 'green';
  }
  // todo fix setter for active
  if (active) {
    styles.color = 'green';
  }

  const iconStyle = { color: textColor, marginTop: '.01em', fontSize: '.7em' };
  let iconDisplay = (
    <span
      className="fa-layers fa-fw"
      onMouseEnter={onMouseEnter}
      onClick={onClick(value)}
    >

      <FontAwesomeIcon
        icon={icon.replace(/^fa-/, '')}
        size="3x"
      />
      <strong className="fa-stack-1x" style={iconStyle} >{value}</strong>

    </span>
  );

  let className = "listFix";

  if (icon === 'none') {
    className = "col-xs-6 col-sm-2 btn btn-default";
    iconDisplay = (
      <span>{name} deltagare</span>
    );
  }

  return (
    <li
      className={className}
      onMouseEnter={onMouseEnter}
      style={styles}
      onClick={onClick(value)}
      {...rest}
    >
      {iconDisplay}

      {children}
    </li>
  );
};

Participant.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  icon: PropTypes.string.isRequired,

  // funcs
  onClick: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func.isRequired,

  // Status
  active: PropTypes.bool.isRequired,
  clicked: PropTypes.bool.isRequired,
  isHover: PropTypes.bool.isRequired,
};

export default Participant;



// WEBPACK FOOTER //
// ./src/components/Resource/components/Participant.js